import React, { FunctionComponent, useState } from "react";
import { Aside, ButtonProps, CommandBarButton } from "sprint-common-web";

import { CreateDistributorForm } from "../forms/create/CreateDistributorForm";

export type AddDistributorButtonProps = ButtonProps;

export const AddDistributorButton: FunctionComponent<AddDistributorButtonProps> = (
    props: AddDistributorButtonProps
) => {
    const { disabled } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" disabled={disabled} />
            <Aside isOpen={isAsideOpen} type="form" headerText={"Add Distributor"} onDismiss={closeAside}>
                <CreateDistributorForm onCancel={closeAside} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};
